import CrossIcon from "../../assets/svg/CrossIcon.svg";
import { Button } from "../ui/button";
import { useFormik } from "formik";
import kanaban from "../../assets/v2/svg/Kanban.svg";
import gantt from "../../assets/v2/svg/Gantt.svg";
import calendar from "../../assets/v2/svg/Calendar.svg";
import list from "../../assets/v2/svg/List.svg";
import { useCallback, useEffect, useMemo, useState } from "react";
import { toFormikValidationSchema } from "zod-formik-adapter";
import {
  buildCreateProjectClientSchema,
  createPortfolioAndProgramSchema,
  createProjectSchema,
  updateProjectSchema,
} from "@backend/src/schemas/projectSchema";
import { z } from "zod";
import useProjectMutation from "@/api/mutation/useProjectMutation";
import { isAxiosError } from "axios";
import useProjectQuery, { Project } from "@/api/query/useProjectQuery";
import useProjectUpdateMutation from "@/api/mutation/useProjectUpdateMutation";
import { toast } from "react-toastify";
import Select, { SingleValue } from "react-select";
import { reactSelectStyle, reactSelectStyleWorkingDays } from "./utils/projectStyles";
import { formatDate, getUniqueCurrencies } from "./utils/projectHelpers";
import ErrorMessage from "../common/ErrorMessage";
import { useNavigate } from "react-router-dom";
import { ProjectDefaultViewEnumValue } from "@backend/src/schemas/enums";
import { errorConfig } from "@/lib/toastError";
import InputText from "../common/InputText";
import { useTranslation } from "react-i18next";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import useAllPortfoliosQuery, {
  Portfolios,
  Program,
} from "@/api/query/useAllPortFoliosQuery";
import Dialog from "../common/Dialog";
import DeletePortfolioProgramConfirmDialog from "./DeletePortfolioProgramConfirmDialog";
import useCreatePortfolioProgramMutation from "@/api/mutation/useCreatePortfolioProgram";
import TrashCan from "@/assets/svg/TrashCan.svg";
import Loader from "../common/Loader";
import useRemovePortfolioMutation from "@/api/mutation/useRemovePortfolioMutaiton";
import useRemoveProgramMutation from "@/api/mutation/useRemoveProgramMutaiton";
import useProjectWithoutCalulationQuery from "@/api/query/useProjectWithoutCalulationQuery";
import useProjectManagerPortfolioDashboardQuery from "@/api/query/useProjectManagerPortfolioDashboardQuery";
import { useUser } from "@/hooks/useUser";
import { UserRoleEnumValue } from "@backend/src/schemas/enums";
import { Settings, ChevronDown, ChevronUp, Plus } from "lucide-react";
import useAllWorkstreamsQuery from "@/api/query/useAllWorkstreamsQuery";
import { useCreateWorkstreamMutation } from "@/api/mutation/useWorkstreamMutations";
import useProjectDocumentUploadMutation from "@/api/mutation/useProjectDocumentUploadMutation";
import useAllProjectPhasesQuery from "@/api/query/useAllProjectPhasesQuery";
import useAllProjectPrioritiesQuery from "@/api/query/useAllProjectPrioritiesQuery";
import useOrganisationDetailsQuery from "@/api/query/useOrganisationDetailsQuery";
import useTeamUnitsQuery from "@/api/query/useTeamUnitsQuery";
import useAllProjectTypesQuery from "@/api/query/useAllProjectTypesQuery";
import { OverAllTrackEnumValue, ScheduleAndBudgetTrend } from "@backend/src/schemas/enums";
import Stormy from "../../assets/svg/stormy.svg";
import Cloudy from "../../assets/svg/cloudy.svg";
import Sunny from "../../assets/svg/sunny.svg";
import Rainy from "../../assets/svg/Rainy.svg";
import { components } from "react-select";

type Options = { label: string | JSX.Element; value: string };

type AddProjectType = {
  handleClosePopUp: () => void;
  editData?: Project;
};
function CreateUpdateProjectForm(props: AddProjectType) {
  const { t } = useTranslation();
  const { handleClosePopUp, editData } = props;
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const errorStyle = "text-red-400 block text-xs mt-1";
  const labelStyle = "font-semibold text-sm text-[#44546F] mb-1.5 block";
  const projectMutation = useProjectMutation();
  const projectUpdateMutation = useProjectUpdateMutation(
    editData ? editData.projectId : ""
  );
  const allPortfoliosQuery = useAllPortfoliosQuery(false, true);
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [uploadingDoc, setUploadingDoc] = useState(false);
  const projectDocumentUploadMutation = useProjectDocumentUploadMutation();
  const workstreamsQuery = useAllWorkstreamsQuery(true);
  const projectPhasesQuery = useAllProjectPhasesQuery(true);
  const projectPrioritiesQuery = useAllProjectPrioritiesQuery(true);
  const createWorkstreamMutation = useCreateWorkstreamMutation();
  const [createWorkstreamOpen, setCreateWorkstreamOpen] = useState(false);
  const { user } = useUser();
  const organisationId = user?.userOrganisation[0]?.organisationId ?? "";
  const orgDetailsQuery = useOrganisationDetailsQuery(organisationId, !!organisationId);
  const teamUnitsQuery = useTeamUnitsQuery(organisationId, !!organisationId);
  const projectTypesQuery = useAllProjectTypesQuery(true);

  const [usefulLinks, setUsefulLinks] = useState<string>("");
  const [linkError, setLinkError] = useState<string>("");

  const orgUsersOptions = useMemo(() => {
    return (orgDetailsQuery.data?.data?.data?.userOrganisation || [])
      .filter((member: any) => !member.user.deletedAt)
      .map((member: any) => {
        const fullName = `${member.user.firstName || ""} ${member.user.lastName || ""}`.trim();
        const displayName = fullName || member.user.email;
        return {
          label: displayName,
          value: displayName,
        };
      });
  }, [orgDetailsQuery.data?.data?.data?.userOrganisation]);

  const clientDepartmentOptions = useMemo(() => {
    return (teamUnitsQuery.data?.data?.data || []).map((unit: any) => ({
      label: unit.name,
      value: unit.name,
    }));
  }, [teamUnitsQuery.data?.data?.data]);

  const HandleOverallTrack = (track: string) => {
    switch (track) {
      case OverAllTrackEnumValue.STORMY:
        return <img src={Stormy} className="h-5 w-5 mr-1.5" />;
      case OverAllTrackEnumValue.CLOUDY:
        return <img src={Cloudy} className="h-5 w-5 mr-1.5" />;
      case OverAllTrackEnumValue.SUNNY:
        return <img src={Sunny} className="h-5 w-5 mr-1.5" />;
      case OverAllTrackEnumValue.RAINY:
        return <img src={Rainy} className="h-5 w-5 mr-1.5" />;
      default:
        return null;
    }
  };
  const [currencyValue, setCurrencyValue] = useState<SingleValue<Options>>();
  const RADIO_BUTTON_OPTIONS = [
    {
      id: 4,
      title: "list",
      description: t("list_description"),
      img: list,
    },
    {
      id: 2,
      title: "gantt",
      description: t("gantt_description"),
      img: gantt,
    },
    {
      id: 1,
      title: "kanban",
      description: t("kanban_description"),
      img: kanaban,
    },
    {
      id: 3,
      title: "calendar",
      description: t("calendar_description"),
      img: calendar,
    },
  ];

  const [allPortfolios, setAllPortfolios] = useState<{
    programs: Program[];
    portfolios: Portfolios[];
  }>();
  const [portfolios, setPortfolios] = useState<Options[]>([]);
  const [programs, setPrograms] = useState<Options[]>([]);
  const [workstreamsOptions, setWorkstreamsOptions] = useState<Options[]>([]);
  const [createPortfolio, setCreatePortfolio] = useState<
    "portfolio" | "program"
  >();
  const [deletePortfolioAndProgram, setDeletePortfolioAndProgram] = useState<{
    portfolio: string;
    program: string;
  }>();

  const createPortfolioAndProgramFormik = useFormik({
    initialValues: { program: "", portfolio: "" },
    validationSchema: toFormikValidationSchema(createPortfolioAndProgramSchema),
    onSubmit(values) {
      createPortfolioAndProgram(values);
    },
  });
  const projectQuery = useProjectQuery(false);
  const projectWithoutCalulationQuery = useProjectWithoutCalulationQuery(false)
  const projectManagerPortfolioDashboardQuery =
    useProjectManagerPortfolioDashboardQuery(
      {
        portfolioId: "",
        programId: "",
      },
      false,
    );
  const navigate = useNavigate();

  const validateCreateProject = useCallback(
    (values: z.infer<typeof createProjectSchema>) => {
      const schema = buildCreateProjectClientSchema({
        isAdministrator:
          user?.userOrganisation[0]?.role ===
          UserRoleEnumValue.ADMINISTRATOR,
        managedPortfolioCount:
          allPortfoliosQuery.data?.data.data.portfolios?.length ?? 0,
        managedStandaloneProgramCount:
          allPortfoliosQuery.data?.data.data.programs?.length ?? 0,
      });
      const result = schema.safeParse(values);
      if (result.success) {
        return {};
      }
      const errors: Partial<Record<string, string>> = {};
      for (const issue of result.error.issues) {
        const key = issue.path[0];
        if (typeof key === "string" && errors[key] === undefined) {
          errors[key] = issue.message;
        }
      }
      return errors;
    },
    [
      user?.userOrganisation[0]?.role,
      allPortfoliosQuery.data?.data.data?.portfolios?.length,
      allPortfoliosQuery.data?.data.data?.programs?.length,
    ],
  );

  const portfolioProgramFieldHints = useMemo(() => {
    const isAdministrator =
      user?.userOrganisation[0]?.role === UserRoleEnumValue.ADMINISTRATOR;
    const data = allPortfoliosQuery.data?.data.data;
    const hasPortfolios = (data?.portfolios?.length ?? 0) > 0;
    const hasStandalonePrograms = (data?.programs?.length ?? 0) > 0;
    if (isAdministrator) {
      return { portfolioAsterisk: false, programAsterisk: false };
    }
    if (hasPortfolios && !hasStandalonePrograms) {
      return { portfolioAsterisk: true, programAsterisk: false };
    }
    if (!hasPortfolios && hasStandalonePrograms) {
      return { portfolioAsterisk: false, programAsterisk: true };
    }
    if (hasPortfolios && hasStandalonePrograms) {
      return { portfolioAsterisk: true, programAsterisk: true };
    }
    return { portfolioAsterisk: false, programAsterisk: false };
  }, [
    user?.userOrganisation[0]?.role,
    allPortfoliosQuery.data?.data.data?.portfolios?.length,
    allPortfoliosQuery.data?.data.data?.programs?.length,
  ]);

  const formik = useFormik<z.infer<typeof createProjectSchema>>({
    initialValues: {
      projectName: "",
      projectDescription: "",
      startDate: "" as unknown as Date,
      estimatedEndDate: "" as unknown as Date,
      estimatedBudget: "",
      defaultView: ProjectDefaultViewEnumValue.GANTT,
      currency: "USD",
      portfolio: "",
      program: "",
      isMilestone: false,
      projectCode: "",
      workstream: "",
      priority: "",
      projectPhase: "",
      projectType: "",
      sponsor: "",
      clientDepartment: "",
      tags: [],
      documents: [],
      overallTrack: OverAllTrackEnumValue.SUNNY,
      budgetTrend: ScheduleAndBudgetTrend.STABLE,
      scheduleTrend: ScheduleAndBudgetTrend.STABLE,
      includeInTimesheet: true,
    },
    validationSchema:
      editData && editData.projectId
        ? toFormikValidationSchema(updateProjectSchema)
        : undefined,
    validate:
      editData && editData.projectId ? undefined : validateCreateProject,
    onSubmit: (values, helper) => {
      if (editData && editData.projectId) {
        if (!values.estimatedEndDate) {
          delete values.estimatedEndDate;
        }
        projectUpdateMutation.mutate(values, {
          onSuccess(data) {
            projectQuery.refetch();
            projectWithoutCalulationQuery.refetch();
            projectManagerPortfolioDashboardQuery.refetch()
            formik.resetForm();
            navigate("/projects/");
            handleClosePopUp();
            setIsSubmitting(false);
            toast.success(data.data.message);
          },
          onError(error) {
            setIsSubmitting(false);
            if (isAxiosError(error)) {
              if (
                error.response?.status === 400 &&
                error.response.data?.errors &&
                Array.isArray(error.response?.data.errors)
              ) {
                error.response.data.errors.forEach((item) => {
                  helper.setFieldError(item.path[0], item.message);
                });
              }
              if (!Array.isArray(error.response?.data.errors)) {
                toast.error(
                  errorKeyFormate(error.response?.data.message + ""),
                  errorConfig
                );
              }
            }
          },
        });
      } else {
        if (!values.estimatedEndDate) {
          delete values.estimatedEndDate;
        }
        projectMutation.mutate(values, {
          onSuccess(data) {
            projectQuery.refetch();
            projectWithoutCalulationQuery.refetch()
            formik.resetForm();
            navigate(`/tasks/${data.data.data.projectId}`);
            handleClosePopUp();
            toast.success(data.data.message);
          },
          onError(error) {
            setIsSubmitting(false);
            if (isAxiosError(error)) {
              if (
                error.response?.status === 400 &&
                error.response.data?.errors &&
                Array.isArray(error.response?.data.errors)
              ) {
                error.response.data.errors.forEach((item) => {
                  helper.setFieldError(item.path[0], item.message);
                });
              }
              if (!Array.isArray(error.response?.data.errors)) {
                toast.error(
                  errorKeyFormate(error.response?.data.message + ""),
                  errorConfig
                );
              }
            }
          },
        });
      }
    },
  });

  useEffect(() => {
    if (!allPortfoliosQuery.isFetched) {
      allPortfoliosQuery.refetch()
    }
    const data = allPortfoliosQuery.data?.data.data;
    setAllPortfolios(data);
    setPortfolios([
      { label: t("Select portfolio"), value: "" },
      ...(data?.portfolios ?? []).map(({ portfolioId, portfolioName }) => ({
        value: portfolioId,
        label: (
          <div className={`flex gap-2 justify-between items-center`}>
            {portfolioName}
            {user?.userOrganisation[0]?.role ===
              UserRoleEnumValue.ADMINISTRATOR && (
                <span
                  className={`font-bold text-xs text-red-400 ${formik.values.portfolio == portfolioId ? "hidden" : ""
                    }`}
                  onClick={() => {
                    setDeletePortfolioAndProgram({
                      portfolio: portfolioId,
                      program: "",
                    });
                  }}
                >
                  ✖
                </span>
              )}
          </div>
        ),
      })),
    ]);
  }, [allPortfoliosQuery.data?.data.data, formik.values.portfolio, user]);
  useEffect(() => {
    const selectedPortfolio = formik.values.portfolio
      ? allPortfolios?.portfolios.find(
          ({ portfolioId }) => portfolioId === formik.values.portfolio
        )
      : null;

    if (formik.values.portfolio) {
      const portfolioPrograms = selectedPortfolio?.programs ?? [];
      setPrograms([
        { label: t("Select program"), value: "" },
        ...portfolioPrograms.map(({ programId, programName }) => ({
          value: programId,
          label: (
            <div className="flex gap-2 justify-between items-center">
              {programName}
              {user?.userOrganisation[0]?.role ===
                UserRoleEnumValue.ADMINISTRATOR && (
                  <span
                    className={`font-bold text-xs text-red-400 ${formik.values.program == programId ? "hidden" : ""
                      } `}
                    onClick={() => {
                      setDeletePortfolioAndProgram({
                        portfolio: "",
                        program: programId,
                      });
                    }}
                  >
                    ✖
                  </span>
                )}
            </div>
          ),
        })),
      ]);
    } else {
      // No portfolio selected - show only standalone programs (programs without portfolioId)
      const standalonePrograms = allPortfolios?.programs?.filter(
        (program) => !program.portfolioId
      ) || [];

      setPrograms([
        { label: t("Select program"), value: "" },
        ...(standalonePrograms?.map(({ programId, programName }) => ({
          value: programId,
          label: (
            <div className="flex gap-2 justify-between items-center">
              {programName}
              {user?.userOrganisation[0]?.role ===
                UserRoleEnumValue.ADMINISTRATOR && (
                  <span
                    className={`font-bold text-xs text-red-400 ${formik.values.program == programId ? "hidden" : ""
                      } `}
                    onClick={() => {
                      setDeletePortfolioAndProgram({
                        portfolio: "",
                        program: programId,
                      });
                    }}
                  >
                    ✖
                  </span>
                )}
            </div>
          ),
        })) ?? []),
      ]);
    }
  }, [
    allPortfolios?.portfolios,
    allPortfolios?.programs,
    formik.values.portfolio,
    formik.values.program,
    t,
    user,
  ]);
  useEffect(() => {
    if (workstreamsQuery.data?.data?.data) {
      setWorkstreamsOptions([
        { label: t("Select workstream"), value: "" },
        ...workstreamsQuery.data.data.data.map((w: any) => ({
          value: w.workstreamId,
          label: w.workstreamName,
        }))
      ]);
    }
  }, [workstreamsQuery.data?.data?.data, formik.values.workstream, t, user]);
  useEffect(() => {
    if (editData) {
      formik.setValues({
        startDate: formatDate(editData.startDate) as unknown as Date,
        estimatedEndDate: formatDate(
          editData.estimatedEndDate
        ) as unknown as Date,
        estimatedBudget: editData.estimatedBudget,
        projectDescription: editData.projectDescription,
        projectName: editData.projectName,
        defaultView: editData.defaultView,
        currency: editData.currency,
        portfolio: editData.portfolio?.portfolioId ?? "",
        program: editData.program?.programId ?? "",
        projectCode: editData.projectCode ?? "",
        workstream: editData.workstreamId ?? "",
        priority: (editData.priority as any)?.priorityId ?? "",
        projectPhase: (editData.projectPhase as any)?.projectPhaseId ?? "",
        projectType: (editData.projectType as any)?.projectTypeId ?? "",
        sponsor: editData.sponsor ?? "",
        clientDepartment: editData.clientDepartment ?? "",
        tags: editData.tags ?? [],
        documents: editData.documents ?? [],
        overallTrack: editData.overallTrack ?? OverAllTrackEnumValue.SUNNY,
        budgetTrend: editData.budgetTrend ?? ScheduleAndBudgetTrend.STABLE,
        scheduleTrend: editData.scheduleTrend ?? ScheduleAndBudgetTrend.STABLE,
        includeInTimesheet: editData.includeInTimesheet ?? true,
      });
      setCurrencyValue({ label: editData.currency, value: editData.currency });
    }
  }, []);

  useEffect(() => {
    if (formik.submitCount > 0 && Object.keys(formik.errors).length > 0) {
      const firstErrorKey = Object.keys(formik.errors)[0];
      const element = document.querySelector(`[name="${firstErrorKey}"]`);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        if (element instanceof HTMLElement && !(element instanceof HTMLInputElement && element.type === "date")) {
          element.focus();
        }
      }
    }
  }, [formik.submitCount, formik.errors]);

  const OverallTrackControl = useMemo(() => {
    const ControlComponent = ({ children, ...rest }: any) => (
      <components.Control {...rest}>
        <div className="flex items-center pl-2">
          {HandleOverallTrack(formik.values.overallTrack ?? "")}
        </div>
        {children}
      </components.Control>
    );
    ControlComponent.displayName = "OverallTrackControl";
    return ControlComponent;
  }, [formik.values.overallTrack]);

  const handleCurrency = (val: SingleValue<Options>) => {
    if (val) {
      setCurrencyValue(val);
      formik.setFieldValue("currency", val.value);
    }
  };

  const createPortfolioProgramMutation = useCreatePortfolioProgramMutation();
  const createPortfolioAndProgram = (
    value: z.infer<typeof createPortfolioAndProgramSchema>
  ) => {
    createPortfolioProgramMutation.mutate(value, {
      onSuccess() {
        allPortfoliosQuery.refetch().then((res) => {
          const findPortfolio = res.data?.data.data.portfolios.find(
            (p) => p.portfolioName == value.portfolio
          );
          const findNewProgram = findPortfolio?.programs.find(
            (t) => t.programName == value.program
          );
          formik.setFieldValue("program", findNewProgram?.programId);
          formik.setFieldValue("portfolio", findPortfolio?.portfolioId);
        });
        setCreatePortfolio(undefined);
        createPortfolioAndProgramFormik.resetForm();
      },
      onError(error) {
        toast.error(
          errorKeyFormate(error.response?.data.message ?? ""),
          errorConfig
        );
      },
    });
  };
  const removeProgramMutation = useRemoveProgramMutation();
  const removePortfolioMutation = useRemovePortfolioMutation();
  const handleRemovePortfolioAndProgram = () => {
    if (deletePortfolioAndProgram?.portfolio) {
      removePortfolioMutation.mutate(deletePortfolioAndProgram?.portfolio, {
        onSuccess() {
          allPortfoliosQuery.refetch().then(() => {
            formik.setFieldValue("portfolio", "");
            setDeletePortfolioAndProgram(undefined);
            projectQuery.refetch();
            projectWithoutCalulationQuery.refetch()
          });
        },
        onError(error) {
          toast.error(
            errorKeyFormate(error.response?.data.message ?? ""),
            errorConfig
          );
        },
      });
    }
    if (deletePortfolioAndProgram?.program) {
      removeProgramMutation.mutate(deletePortfolioAndProgram?.program, {
        onSuccess() {
          allPortfoliosQuery.refetch().then(() => {
            formik.setFieldValue("program", "");
            setDeletePortfolioAndProgram(undefined);
            projectQuery.refetch();
            projectWithoutCalulationQuery.refetch()
          });
        },
        onError(error) {
          toast.error(
            errorKeyFormate(error.response?.data.message ?? ""),
            errorConfig
          );
        },
      });
    }
  };

  return (
    <div className="fixed bg-[#00000066] w-full top-0 left-0 h-full items-center flex justify-center z-50">
      {allPortfoliosQuery.isLoading && (
        <Loader className="absolute top-0 left-0 bg-white z-[60]" />
      )}
      <div className="lg:rounded-3xl border border-white/50 bg-[#fff] md:max-w-6xl w-full flex flex-col h-auto max-h-[90vh] overflow-hidden shadow-2xl relative">
        {/* Header */}
        <div className="flex justify-between items-center px-8 py-5 border-b border-gray-100">
          <div className="text-xl font-bold text-[#172B4D]">
            {editData ? t("edit_project") : t("create_new_project")}
          </div>
          <div
            onClick={handleClosePopUp}
            className="flex items-center justify-center cursor-pointer p-1 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <img src={CrossIcon} className="w-3 min-w-3" alt="Close" />
          </div>
        </div>

        {/* Scrollable Content */}
        <div className="flex-grow overflow-y-auto px-8 py-6">
          <form onSubmit={formik.handleSubmit} className="w-full flex flex-col gap-6">
            <div className="grid grid-cols-12 gap-8">
              {/* Left Column: Input Fields */}
              <div className="col-span-12 lg:col-span-7 flex flex-col gap-5">
                {/* Project Name */}
                <div className="text-left w-full">
                  <label className={labelStyle}>
                    {t("project_name")} <span className="text-red-500">*</span>
                  </label>
                  <InputText
                    name="projectName"
                    placeholder="e.g. Construction usine industrielle"
                    value={formik.values.projectName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="mt-0"
                  />
                  <span className={errorStyle}>
                    {(formik.touched.projectName || formik.submitCount > 0) &&
                      formik.errors.projectName &&
                      t(formik.errors.projectName)}
                  </span>
                </div>

                {/* Portfolio & Program side by side */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full text-left">
                  {/* Portfolio */}
                  <div>
                    <label className={labelStyle}>
                      {t("Portfolio")}
                      {!editData?.projectId &&
                        portfolioProgramFieldHints.portfolioAsterisk && (
                          <span className="ml-0.5 text-red-500">*</span>
                        )}
                    </label>
                    <div className="flex items-center gap-2">
                      <Select
                        key={formik.values.portfolio}
                        className="w-full mt-0"
                        placeholder="Select Portfolio"
                        options={portfolios}
                        value={portfolios.find(
                          (option) =>
                            option.value === (formik.values.portfolio ?? "")
                        )}
                        styles={reactSelectStyle}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        onChange={(e) => {
                          const val = e as Options;
                          if (val && val.value) {
                            formik.setFieldValue("portfolio", val.value);
                            const label =
                              allPortfoliosQuery.data?.data.data.portfolios.find(
                                (t) => t.portfolioId == val.value
                              );
                            createPortfolioAndProgramFormik.setFieldValue(
                              "portfolio",
                              label?.portfolioName
                            );
                          } else {
                            formik.setFieldValue("portfolio", "");
                            createPortfolioAndProgramFormik.setFieldValue(
                              "portfolio",
                              ""
                            );
                          }
                          formik.setFieldValue("program", "");
                        }}
                      />
                      {user?.userOrganisation[0]?.role ===
                        UserRoleEnumValue.ADMINISTRATOR && (
                          <button
                            type="button"
                            onClick={() => setCreatePortfolio("portfolio")}
                            className="border h-[38px] w-[38px] flex items-center justify-center border-gray-300 rounded-md hover:bg-gray-50 bg-white shrink-0"
                          >
                            <Plus className="w-5 h-5 text-blue-600" strokeWidth={2.5} />
                          </button>
                        )}
                    </div>
                    <span className={errorStyle}>
                      {(formik.touched.portfolio || formik.submitCount > 0) &&
                        formik.errors.portfolio &&
                        t(formik.errors.portfolio)}
                    </span>
                  </div>

                  {/* Program */}
                  <div>
                    <label className={labelStyle}>
                      {t("Program")}
                      {!editData?.projectId &&
                        portfolioProgramFieldHints.programAsterisk && (
                          <span className="ml-0.5 text-red-500">*</span>
                        )}
                    </label>
                    <div className="flex items-center gap-2">
                      <Select
                        key={`${formik.values.portfolio}${formik.values.program}`}
                        className="w-full mt-0"
                        placeholder={formik.values.portfolio ? "Select Program" : "Select a portfolio first"}
                        options={programs}
                        styles={reactSelectStyle}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        value={programs.find(
                          (option) =>
                            option.value === (formik.values.program ?? "")
                        )}
                        onChange={(e) => {
                          const val = e as Options;
                          if (val && val.value) {
                            formik.setFieldValue("program", val.value);
                            const selectedProgram = allPortfoliosQuery.data?.data.data.portfolios
                              .flatMap(p => p.programs)
                              .find(program => program.programId === val.value);

                            if (selectedProgram?.portfolioId) {
                               formik.setFieldValue("portfolio", selectedProgram.portfolioId);
                               const portfolioLabel = allPortfoliosQuery.data?.data.data.portfolios
                                 .find(p => p.portfolioId === selectedProgram.portfolioId);
                               if (portfolioLabel) {
                                 createPortfolioAndProgramFormik.setFieldValue(
                                   "portfolio",
                                   portfolioLabel.portfolioName
                                 );
                               }
                            }
                          } else {
                            formik.setFieldValue("program", "");
                          }
                        }}
                      />
                      {user?.userOrganisation[0]?.role ===
                        UserRoleEnumValue.ADMINISTRATOR && (
                          <button
                            type="button"
                            onClick={() => {
                              setCreatePortfolio("program");
                              const label =
                                allPortfoliosQuery.data?.data.data.portfolios.find(
                                  (t) =>
                                    t.portfolioId == formik.values.portfolio
                                );
                              createPortfolioAndProgramFormik.setFieldValue(
                                "portfolio",
                                label?.portfolioName
                              );
                            }}
                            className="border h-[38px] w-[38px] flex items-center justify-center border-gray-300 rounded-md hover:bg-gray-50 bg-white shrink-0"
                          >
                            <Plus className="w-5 h-5 text-blue-600" strokeWidth={2.5} />
                          </button>
                        )}
                    </div>
                    <span className={errorStyle}>
                      {(formik.touched.program || formik.submitCount > 0) &&
                        formik.errors.program &&
                        t(formik.errors.program)}
                    </span>
                  </div>
                </div>

                {/* Description (Objectives) */}
                <div className="text-left w-full">
                  <label className={labelStyle}>{t("Project Objectives")}</label>
                  <textarea
                    rows={3}
                    name="projectDescription"
                    placeholder={t("Project Objectives")}
                    className="w-full border border-gray-300 rounded-md px-3 py-1.5 text-sm focus:outline-[#353dcc] resize-none"
                    value={formik.values.projectDescription}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  <span className={errorStyle}>
                    {formik.touched.projectDescription &&
                      t(formik.errors.projectDescription as string)}
                  </span>
                </div>

                {/* Start Date & Estimated End Date side by side */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full text-left">
                  <div>
                    <label className={labelStyle}>
                      {t("start_date")} <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="date"
                      name="startDate"
                      className="w-full border border-gray-300 rounded-md px-3 py-1.5 h-[39px] text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 focus:outline-none"
                      value={formik.values.startDate as unknown as string}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    <span className={errorStyle}>
                      {(formik.touched.startDate || formik.submitCount > 0) &&
                        (formik.errors.startDate as string)}
                    </span>
                  </div>
                  <div>
                    <label className={labelStyle}>{t("estimated_end_date")}</label>
                    <input
                      type="date"
                      name="estimatedEndDate"
                      className="w-full border border-gray-300 rounded-md px-3 py-1.5 h-[39px] text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 focus:outline-none"
                      value={(formik.values.estimatedEndDate as unknown as string) ?? ""}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      min={formik.values.startDate ? (formik.values.startDate as unknown as string) : undefined}
                    />
                    <span className={errorStyle}>
                      {(formik.touched.estimatedEndDate || formik.submitCount > 0) &&
                        (formik.errors.estimatedEndDate as string)}
                    </span>
                  </div>
                </div>

                {/* Currency & Estimated Budget side by side */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full text-left">
                  <div className="col-span-1">
                    <label className={labelStyle}>{t("currency")}</label>
                    <Select
                      onChange={handleCurrency}
                      onBlur={() => formik.setTouched({ currency: true })}
                      options={getUniqueCurrencies()}
                      value={currencyValue}
                      defaultValue={{ label: "USD", value: "USD" }}
                      placeholder="USD"
                      name="currency"
                      styles={reactSelectStyle}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                    />
                    <ErrorMessage>
                      {(formik.touched.currency || formik.submitCount > 0) && formik.errors.currency}
                    </ErrorMessage>
                  </div>
                  <div className="col-span-2">
                    <label className={labelStyle}>{t("estimated_budget")}</label>
                    <InputText
                      name="estimatedBudget"
                      placeholder="e.g. 2,500,000.00"
                      className="mt-0"
                      value={formik.values.estimatedBudget ?? ""}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    <span className={errorStyle}>
                      {(formik.touched.estimatedBudget || formik.submitCount > 0) &&
                        formik.errors.estimatedBudget}
                    </span>
                  </div>
                </div>
              </div>

              {/* Right Column: Default View Selector */}
              <div className="col-span-12 lg:col-span-5 flex flex-col gap-4 text-left">
                <div className="text-sm font-semibold text-[#44546F] mb-1.5">
                  {t("Default View")}
                </div>
                <div className="flex flex-col gap-3">
                  {RADIO_BUTTON_OPTIONS.map((radioButton) => {
                    const isActive = formik.values.defaultView === radioButton.title.toUpperCase();
                    return (
                      <div
                        key={radioButton.id}
                        className={`w-full rounded-2xl border transition-all duration-200 cursor-pointer ${isActive
                          ? "border-[#353dcc] bg-[#e0e0ff]/30 shadow-sm"
                          : "border-gray-200 bg-white hover:border-gray-300"
                          }`}
                        onClick={() => formik.setFieldValue("defaultView", radioButton.title.toUpperCase())}
                      >
                        <div className="flex gap-4 p-4 items-center">
                          <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${isActive ? "bg-[#353dcc] text-white" : "bg-[#f4f5f7] text-[#44546F]"
                            }`}>
                            <img
                              src={radioButton.img}
                              className={`w-5 h-5 ${isActive ? "brightness-0 invert" : "brightness-0 opacity-60"}`}
                              alt=""
                            />
                          </div>
                          <div className="flex flex-col flex-grow">
                            <div className={`font-bold text-sm ${isActive ? "text-[#353dcc]" : "text-[#172B4D]"}`}>
                              {t(radioButton.title)}
                            </div>
                            <div className="text-xs text-gray-500 leading-normal mt-0.5">
                              {radioButton.description}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Bottom Section: Advanced Options */}
            <div className="w-full mt-4">
              <div className="border border-gray-150 rounded-2xl overflow-hidden bg-[#fafbfc]/50">
                <div
                  className="flex justify-between items-center p-5 cursor-pointer hover:bg-[#f4f5f7]/50 transition-colors"
                  onClick={() => setShowAdvanced(!showAdvanced)}
                >
                  <div className="flex items-center gap-4">
                    <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-gray-100 text-gray-600">
                      <Settings className="w-5 h-5" />
                    </div>
                    <div className="text-left">
                      <h4 className="font-bold text-[#172B4D] text-sm">{t("Advanced Options")}</h4>
                      <p className="text-xs text-gray-500 mt-0.5">{t("Configure additional project settings (optional)")}</p>
                    </div>
                  </div>
                  <div>
                    {showAdvanced ? <ChevronUp className="w-5 h-5 text-gray-400" /> : <ChevronDown className="w-5 h-5 text-gray-400" />}
                  </div>
                </div>

                {showAdvanced && (
                  <div className="p-6 border-t border-gray-100 bg-white grid grid-cols-1 md:grid-cols-3 gap-8">
                    {/* GENERAL COLUMN */}
                    <div className="flex flex-col gap-5 text-left">
                      <h5 className="text-xs font-bold text-[#353dcc] uppercase tracking-wider">{t("General")}</h5>
                      <div>
                        <label className={labelStyle}>{t("Project Code")}</label>
                        <InputText
                          name="projectCode"
                          placeholder={t("Enter project code")}
                          value={formik.values.projectCode || ""}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          className="mt-0"
                        />
                      </div>
                      <div>
                        <label className={labelStyle}>{t("Sponsor")}</label>
                        <Select
                          className="w-full mt-0"
                          options={orgUsersOptions}
                          styles={reactSelectStyle}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          value={formik.values.sponsor ? { label: formik.values.sponsor, value: formik.values.sponsor } : null}
                          onChange={(e: any) => formik.setFieldValue("sponsor", e?.value)}
                        />
                      </div>
                      <div>
                        <label className={labelStyle}>{t("Workstream / Theme")}</label>
                        <Select
                          className="w-full mt-0"
                          placeholder={t("Select Workstream")}
                          options={workstreamsOptions}
                          styles={reactSelectStyle}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          value={
                            workstreamsOptions.find((t: any) => t.value === formik.values.workstream) || null
                          }
                          onChange={(e: any) => formik.setFieldValue("workstream", e?.value || "")}
                        />
                      </div>
                      <div>
                        <label className={labelStyle}>{t("Client / Department")}</label>
                        <Select
                          className="w-full mt-0"
                          options={clientDepartmentOptions}
                          styles={reactSelectStyle}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          value={formik.values.clientDepartment ? { label: formik.values.clientDepartment, value: formik.values.clientDepartment } : null}
                          onChange={(e: any) => formik.setFieldValue("clientDepartment", e?.value)}
                        />
                      </div>
                      <div>
                        <label className={labelStyle}>{t("Priority")}</label>
                        <Select
                          value={formik.values.priority ? {
                            label: (() => {
                              const matched = projectPrioritiesQuery.data?.data?.data?.find((p: any) => p.priorityId === formik.values.priority);
                              return matched?.priorityName || formik.values.priority;
                            })(),
                            value: formik.values.priority,
                          } : null}
                          onChange={(e: any) => formik.setFieldValue("priority", e?.value)}
                          options={(projectPrioritiesQuery.data?.data?.data ?? []).map((p: any) => ({
                            label: p.priorityName,
                            value: p.priorityId,
                          }))}
                          styles={reactSelectStyle}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                        />
                      </div>
                      <div>
                        <label className={labelStyle}>{t("Project Phase")}</label>
                        <Select
                          value={formik.values.projectPhase ? {
                            label: (() => {
                              const matched = projectPhasesQuery.data?.data?.data?.find((p: any) => p.projectPhaseId === formik.values.projectPhase);
                              return matched?.phaseName || formik.values.projectPhase;
                            })(),
                            value: formik.values.projectPhase,
                          } : null}
                          onChange={(e: any) => formik.setFieldValue("projectPhase", e?.value)}
                          options={(projectPhasesQuery.data?.data?.data ?? []).map((p: any) => ({
                            label: p.phaseName,
                            value: p.projectPhaseId,
                          }))}
                          styles={reactSelectStyle}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                        />
                      </div>
                      <div>
                        <label className={labelStyle}>{t("Project Type")}</label>
                        <Select
                          value={formik.values.projectType ? {
                            label: (() => {
                              const matched = projectTypesQuery.data?.data?.data?.find((p: any) => p.projectTypeId === formik.values.projectType);
                              return matched?.projectTypeName || formik.values.projectType;
                            })(),
                            value: formik.values.projectType,
                          } : null}
                          onChange={(e: any) => formik.setFieldValue("projectType", e?.value)}
                          options={(projectTypesQuery.data?.data?.data ?? []).map((p: any) => ({
                            label: p.projectTypeName,
                            value: p.projectTypeId,
                          }))}
                          styles={reactSelectStyle}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                        />
                      </div>
                    </div>

                    {/* REPORTING COLUMN */}
                    <div className="flex flex-col gap-5 text-left">
                      <h5 className="text-xs font-bold text-[#353dcc] uppercase tracking-wider">{t("Reporting")}</h5>
                      <div>
                        <label className={labelStyle}>{t("overall_track")}</label>
                        <Select
                          menuPlacement="auto"
                          value={
                            formik.values.overallTrack && {
                              label: t(formik.values.overallTrack),
                              value: formik.values.overallTrack,
                            }
                          }
                          components={{
                            Control: OverallTrackControl,
                          }}
                          name="overallTrack"
                          isMulti={false}
                          onChange={(e: SingleValue<Options>) =>
                            formik.setFieldValue("overallTrack", e?.value)
                          }
                          options={Object.keys(OverAllTrackEnumValue).map((i) => {
                            return {
                              label: (
                                <div className="flex items-center gap-2">
                                  {HandleOverallTrack(i)}
                                  {t(i)}
                                </div>
                              ),
                              value: i,
                            } as unknown as Options;
                          })}
                          styles={reactSelectStyle}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                        />
                        <ErrorMessage>
                          {(formik.touched.overallTrack || formik.submitCount > 0) && formik.errors.overallTrack}
                        </ErrorMessage>
                      </div>
                      <div>
                        <label className={labelStyle}>{t("schedule_trend")}</label>
                        <Select
                          menuPlacement="auto"
                          value={
                            formik.values.scheduleTrend ? {
                              label: t(formik.values.scheduleTrend),
                              value: formik.values.scheduleTrend,
                            } : null
                          }
                          name="scheduleTrend"
                          isMulti={false}
                          onChange={(e: SingleValue<Options>) =>
                            formik.setFieldValue("scheduleTrend", e?.value)
                          }
                          options={Object.keys(ScheduleAndBudgetTrend).map((i) => ({
                            label: t(i),
                            value: i,
                          }))}
                          styles={reactSelectStyle}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                        />
                        <ErrorMessage>
                          {(formik.touched.scheduleTrend || formik.submitCount > 0) && formik.errors.scheduleTrend}
                        </ErrorMessage>
                      </div>
                      <div>
                        <label className={labelStyle}>{t("budget_trend")}</label>
                        <Select
                          menuPlacement="auto"
                          value={
                            formik.values.budgetTrend ? {
                              label: t(formik.values.budgetTrend),
                              value: formik.values.budgetTrend,
                            } : null
                          }
                          name="budgetTrend"
                          isMulti={false}
                          onChange={(e: SingleValue<Options>) =>
                            formik.setFieldValue("budgetTrend", e?.value)
                          }
                          options={Object.keys(ScheduleAndBudgetTrend).map((i) => ({
                            label: t(i),
                            value: i,
                          }))}
                          styles={reactSelectStyle}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                        />
                        <ErrorMessage>
                          {(formik.touched.budgetTrend || formik.submitCount > 0) && formik.errors.budgetTrend}
                        </ErrorMessage>
                      </div>
                      <div>
                        <label className={labelStyle}>{t("Available in Timesheets")}</label>
                        <Select
                          menuPlacement="auto"
                          value={
                            formik.values.includeInTimesheet
                              ? { label: t("Yes"), value: true }
                              : { label: t("No"), value: false }
                          }
                          onChange={(e: any) => formik.setFieldValue("includeInTimesheet", e?.value)}
                          options={[
                            { label: t("Yes"), value: true },
                            { label: t("No"), value: false },
                          ]}
                          styles={reactSelectStyle}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                        />
                        <ErrorMessage>
                          {(formik.touched.includeInTimesheet || formik.submitCount > 0) && formik.errors.includeInTimesheet}
                        </ErrorMessage>
                      </div>
                    </div>

                    {/* ADDITIONAL COLUMN */}
                    <div className="flex flex-col gap-5 text-left">
                      <h5 className="text-xs font-bold text-[#353dcc] uppercase tracking-wider">{t("Additional Information")}</h5>
                      {/* Tags */}
                      <div>
                        <label className={labelStyle}>{t("Project Tags")}</label>
                        <div className="flex flex-wrap gap-1.5 p-2 border border-gray-300 rounded-md bg-white min-h-[39px]">
                          {(formik.values.tags || []).map((tag: string) => (
                            <span key={tag} className="flex items-center gap-1 bg-gray-100 text-gray-800 text-xs px-2 py-0.5 rounded">
                              {tag}
                              <button
                                type="button"
                                onClick={() => formik.setFieldValue("tags", (formik.values.tags || []).filter((t: string) => t !== tag))}
                                className="text-gray-500 hover:text-gray-700 font-bold"
                              >
                                ×
                              </button>
                            </span>
                          ))}
                          <input
                            type="text"
                            placeholder={t("Add tag...")}
                            className="border-none outline-none focus:outline-none focus:ring-0 text-xs flex-grow bg-transparent"
                            onKeyDown={(e: any) => {
                              if (e.key === "Enter" && e.target.value.trim()) {
                                e.preventDefault();
                                const newTag = e.target.value.trim();
                                const currentTags = formik.values.tags || [];
                                if (!currentTags.includes(newTag)) {
                                  formik.setFieldValue("tags", [...currentTags, newTag]);
                                }
                                e.target.value = "";
                              }
                            }}
                          />
                        </div>
                      </div>

                      {/* Reference Documents */}
                      <div>
                        <div className="flex justify-between items-center mb-1.5">
                          <label className="font-semibold text-sm text-[#44546F]">{t("Reference Documents")}</label>
                          <div className="relative">
                            <input
                              type="file"
                              id="projectDocumentFilePopup"
                              className="absolute inset-0 opacity-0 cursor-pointer w-0 h-0"
                              disabled={uploadingDoc}
                              onChange={(e) => {
                                const file = e.target.files?.[0];
                                if (file) {
                                  setUploadingDoc(true);
                                  const formData = new FormData();
                                  formData.append("documentFile", file);
                                  projectDocumentUploadMutation.mutate(formData, {
                                    onSuccess(res) {
                                      const uploadedData = res.data.data;
                                      formik.setFieldValue("documents", [
                                        ...(formik.values.documents || []),
                                        {
                                          documentName: uploadedData.documentName,
                                          documentUrl: uploadedData.documentUrl,
                                        },
                                      ]);
                                      setUploadingDoc(false);
                                      toast.success(t("Document uploaded successfully"));
                                    },
                                    onError(error: any) {
                                      toast.error(error.response?.data?.message || t("Failed to upload document"));
                                      setUploadingDoc(false);
                                    },
                                  });
                                }
                              }}
                            />
                            <button
                              type="button"
                              className="text-xs text-blue-600 hover:underline font-bold"
                              onClick={() => document.getElementById("projectDocumentFilePopup")?.click()}
                            >
                              {uploadingDoc ? t("Uploading...") : t("Add document")}
                            </button>
                          </div>
                        </div>
                        <div className="flex flex-col gap-1.5 max-h-[120px] overflow-y-auto">
                          {(formik.values.documents || [])
                            .filter((doc: any) => doc.documentUrl.includes("/project-documents/") || doc.documentUrl.includes("amazonaws.com"))
                            .map((doc: any, idx: number) => (
                              <div key={idx} className="flex items-center gap-2 px-3 py-1.5 border border-gray-300 rounded-md bg-gray-50 text-xs w-full justify-between">
                                <a href={doc.documentUrl} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline overflow-hidden text-ellipsis whitespace-nowrap max-w-[150px]">
                                  📄 {doc.documentName}
                                </a>
                                <button
                                  type="button"
                                  onClick={() => {
                                    const updatedDocs = (formik.values.documents || []).filter((d: any) => d.documentUrl !== doc.documentUrl);
                                    formik.setFieldValue("documents", updatedDocs);
                                  }}
                                  className="text-red-500 font-bold"
                                >
                                  ×
                                </button>
                              </div>
                            ))}
                        </div>
                      </div>

                      {/* Useful Links */}
                      <div>
                        <div className="flex justify-between items-center mb-1.5">
                          <label className="font-semibold text-sm text-[#44546F]">{t("Useful Links")}</label>
                        </div>
                        <div className="flex gap-2 items-center mb-2">
                          <InputText
                            name="usefulLinks"
                            placeholder="SharePoint, Confluence, etc."
                            className="flex-grow mt-0"
                            value={usefulLinks}
                            onChange={(e: any) => {
                              setUsefulLinks(e.target.value);
                              if (linkError) setLinkError("");
                            }}
                          />
                          <Button
                            type="button"
                            variant="none"
                            className="border border-blue-600 text-blue-600 hover:bg-blue-50 px-3 py-1.5 text-xs h-[39px] shrink-0 font-bold rounded-lg"
                            onClick={() => {
                              const trimmed = usefulLinks.trim();
                              if (!trimmed) {
                                setLinkError(t("Please enter a link"));
                                return;
                              }
                              let urlString = trimmed;
                              if (!/^https?:\/\//i.test(urlString)) {
                                urlString = `https://${urlString}`;
                              }
                              try {
                                const url = new URL(urlString);
                                const hostname = url.hostname;
                                const hasDot = hostname.includes('.');
                                const isLocalhost = hostname === 'localhost';
                                if (!hasDot && !isLocalhost) {
                                  throw new Error("Invalid domain");
                                }
                                const currentDocs = formik.values.documents || [];
                                formik.setFieldValue("documents", [
                                  ...currentDocs,
                                  {
                                    documentName: trimmed,
                                    documentUrl: urlString,
                                  },
                                ]);
                                setUsefulLinks("");
                                setLinkError("");
                              } catch (e) {
                                setLinkError(t("Please enter a valid URL"));
                              }
                            }}
                          >
                            {t("Add")}
                          </Button>
                        </div>
                        {linkError && (
                          <p className="text-red-500 text-xs font-semibold mb-2">{linkError}</p>
                        )}
                        <div className="flex flex-col gap-1.5 max-h-[120px] overflow-y-auto">
                          {(formik.values.documents || [])
                            .filter((doc: any) => !doc.documentUrl.includes("/project-documents/") && !doc.documentUrl.includes("amazonaws.com"))
                            .map((doc: any, idx: number) => (
                              <div key={idx} className="flex items-center gap-2 px-3 py-1.5 border border-gray-300 rounded-md bg-gray-50 text-xs w-full justify-between">
                                <a href={doc.documentUrl} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline overflow-hidden text-ellipsis whitespace-nowrap max-w-[150px]">
                                  🔗 {doc.documentName}
                                </a>
                                <button
                                  type="button"
                                  onClick={() => {
                                    const updatedDocs = (formik.values.documents || []).filter((d: any) => d.documentUrl !== doc.documentUrl);
                                    formik.setFieldValue("documents", updatedDocs);
                                  }}
                                  className="text-red-500 font-bold"
                                >
                                  ×
                                </button>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>

        {/* Footer */}
        <div className="flex justify-end items-center gap-3 px-8 py-4 border-t border-gray-100 bg-[#fafbfc]">
          <Button
            type="button"
            variant="none"
            className="text-[#44546F] hover:text-[#172B4D] font-semibold px-3.5 h-8 text-xs bg-transparent border-none"
            onClick={handleClosePopUp}
          >
            {t("cancel")}
          </Button>
          <Button
            type="submit"
            variant="none"
            className="bg-[#535EF9] hover:bg-[#535EF9]/90 text-white px-3.5 h-8 text-xs font-semibold rounded-lg border-none shadow-[0_4px_12px_rgba(83,94,249,0.15)] transition-all"
            isLoading={isSubmitting}
            disabled={isSubmitting}
            onClick={() => formik.handleSubmit()}
          >
            {editData ? t("save") : t("Save Project")}
          </Button>
        </div>
      </div>
      <Dialog
        isOpen={Boolean(createPortfolio)}
        onClose={() => setCreatePortfolio(undefined)}
        modalClass="rounded-md p-6 w-96 max-h-full h-auto"
      >
        <div className="">
          <div className="flex gap-2 justify-between items-center mb-2">
            <h2 className="text-gray-800">
              {createPortfolio == "portfolio"
                ? t("Create Portfolio")
                : t("Create Program")}
            </h2>
            <div>
              <img
                src={CrossIcon}
                className="w-3 min-w-3 cursor-pointer"
                onClick={() => {
                  setCreatePortfolio(undefined);
                }}
              />
            </div>
          </div>
          {createPortfolio == "portfolio" && (
            <div>
              <label className={labelStyle + " !mt-2"}>{t("Portfolio")}</label>
              <InputText
                onChange={createPortfolioAndProgramFormik.handleChange}
                onBlur={createPortfolioAndProgramFormik.handleBlur}
                name="portfolio"
                className="mt-0"
              />
              {createPortfolioAndProgramFormik.touched.portfolio &&
                createPortfolioAndProgramFormik.errors.portfolio && (
                  <ErrorMessage>
                    {createPortfolioAndProgramFormik.errors.portfolio}
                  </ErrorMessage>
                )}
            </div>
          )}
          {createPortfolio == "program" && (
            <div>
              <div>
                <div className="flex gap-2 justify-between items-center">
                  <label className={labelStyle}>{t("Portfolio")}</label>
                </div>
                <Select
                  key={createPortfolioAndProgramFormik.values.portfolio}
                  className="mt-2"
                  placeholder="Select Portfolio"
                  options={portfolios}
                  isDisabled={Boolean(formik.values.portfolio)}
                  value={portfolios.find((option) => {
                    const portfolio =
                      allPortfoliosQuery.data?.data.data.portfolios.find(
                        (t) =>
                          t.portfolioName ==
                          createPortfolioAndProgramFormik.values.portfolio
                      );
                    if (option.value == portfolio?.portfolioId) {
                      return option;
                    }
                  })}
                  styles={{
                    ...reactSelectStyleWorkingDays,
                  }}
                  onChange={(e) => {
                    const val = e as Options;
                    if (val && val.value) {
                      const findPort = allPortfolios?.portfolios.find(
                        (e) => e.portfolioId == val.value
                      );
                      createPortfolioAndProgramFormik.setFieldValue(
                        "portfolio",
                        findPort?.portfolioName
                      );
                    } else {
                      createPortfolioAndProgramFormik.setFieldValue(
                        "portfolio",
                        ""
                      );
                    }
                  }}
                ></Select>
              </div>
              <div>
                <label className={labelStyle + " !mt-2"}>{t("Program")}</label>
                <InputText
                  onChange={createPortfolioAndProgramFormik.handleChange}
                  onBlur={createPortfolioAndProgramFormik.handleBlur}
                  name="program"
                  className="mt-0 z-50"
                />
                {createPortfolioAndProgramFormik.touched.program &&
                  createPortfolioAndProgramFormik.errors.program && (
                    <ErrorMessage>
                      {createPortfolioAndProgramFormik.errors.program}
                    </ErrorMessage>
                  )}
              </div>
            </div>
          )}
          <div className="flex gap-2 items-center justify-end w-full mt-2">
            <Button
              type="button"
              variant={"primary_outline"}
              onClick={() => {
                setCreatePortfolio(undefined);
              }}
              isLoading={createPortfolioProgramMutation.isPending}
            >
              {t("cancel")}
            </Button>
            <Button
              type="button"
              variant={"primary"}
              onClick={() => {
                createPortfolioAndProgramFormik.submitForm();
              }}
              isLoading={createPortfolioProgramMutation.isPending}
            >
              {t("submit")}
            </Button>
          </div>
        </div>
      </Dialog>
      <DeletePortfolioProgramConfirmDialog
        isOpen={Boolean(
          deletePortfolioAndProgram?.portfolio ||
          deletePortfolioAndProgram?.program
        )}
        isPortfolio={!!deletePortfolioAndProgram?.portfolio}
        isLoading={
          removePortfolioMutation.isPending ||
          removeProgramMutation.isPending
        }
        trashIcon={TrashCan}
        onClose={() => setDeletePortfolioAndProgram(undefined)}
        onConfirm={handleRemovePortfolioAndProgram}
      />
      <Dialog
        isOpen={createWorkstreamOpen}
        onClose={() => setCreateWorkstreamOpen(false)}
        modalClass="rounded-lg w-4/12 text-left bg-white z-[70] p-6"
      >
        <div className="flex flex-col gap-4">
          <h3 className="text-lg font-bold">{t("Create Workstream / Theme")}</h3>
          <div>
            <label className="text-[#44546F] font-semibold text-sm mb-1.5 block">
              {t("Workstream Name")} <span className="text-red-500">*</span>
            </label>
            <input
              id="newWorkstreamNamePopup"
              type="text"
              className="w-full border border-gray-300 rounded-md px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder={t("Enter workstream name")}
            />
          </div>
          <div className="flex gap-2 justify-end mt-4">
            <Button
              variant={"outline"}
              onClick={() => setCreateWorkstreamOpen(false)}
            >
              {t("cancel")}
            </Button>
            <Button
              variant={"primary"}
              onClick={async () => {
                const input = document.getElementById("newWorkstreamNamePopup") as HTMLInputElement;
                const name = input?.value?.trim();
                if (name) {
                  createWorkstreamMutation.mutate({ workstreamName: name }, {
                    onSuccess(res: any) {
                      workstreamsQuery.refetch().then(() => {
                        formik.setFieldValue("workstream", res.data.data.workstreamId);
                        setCreateWorkstreamOpen(false);
                        toast.success(t("Workstream created successfully"));
                      });
                    },
                    onError(err: any) {
                      toast.error(err.response?.data?.message || t("Error creating workstream"));
                    }
                  });
                }
              }}
              isLoading={createWorkstreamMutation.isPending}
            >
              {t("submit")}
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default CreateUpdateProjectForm;
